import { useClientRecordTimeline } from "@/lib/clientRecordQueries";

const KIND_LABELS = {
  session_booked: "Session", session_cancelled: "Session cancelled", session_no_show: "No-show",
  feedback_published: "Feedback", review_submitted: "Review",
};

export default function TimelineTab({ workspaceId, memberId }) {
  const { data, isPending, isError } = useClientRecordTimeline(workspaceId, memberId);

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="client-360-timeline-loading">Loading timeline…</p>;
  if (isError) return <p className="text-sm text-red-600" data-testid="client-360-timeline-error">Couldn't load timeline.</p>;
  if (data.items.length === 0) return <p className="text-sm text-ink-soft" data-testid="client-360-timeline-empty">No activity yet.</p>;

  return (
    <ol className="space-y-3" data-testid="client-360-timeline-tab">
      {data.items.map((e, i) => (
        <li key={i} className="flex items-start gap-3 border-l-2 border-ink/10 pl-3" data-testid={`client-360-timeline-item-${i}`}>
          <div>
            <p className="text-xs text-ink-soft uppercase tracking-wide">{KIND_LABELS[e.kind] || e.kind}</p>
            <p className="text-sm text-ink">{e.label}</p>
            <p className="text-xs text-ink-soft">{new Date(e.at).toLocaleString("en-US", { timeZone: "America/Sao_Paulo" })}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
